import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { param } from 'jquery';

import { PushService } from 'rev-shared/push/PushService';
import { lastValueFrom } from 'rxjs';

import { UploadService } from './Upload.Service';

const IMPORT_RESPONSE_DOWNLOADING_FINISHED: string = 'DownloadingVideoFinished';

@Injectable()
export class WebExService {
	constructor(
		private http: HttpClient,
		private PushService: PushService,
		private UploadService: UploadService
	) {
	}

	public getRecordings(webexSiteSettingsId: string, teamId: string) {
		const url = teamId && teamId.length > 0 ?
			`/media/videos/webex/${webexSiteSettingsId}/get-recordings?teamId=${teamId}` :
			`/media/videos/webex/${webexSiteSettingsId}/get-recordings`;
		return lastValueFrom(this.http.post(url, {
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
		}))
			.then(data => {
				data = data || [];
				return (data as any[])
					.map(recording => ({
						...recording,
						durationInMs: recording.durationSeconds * 1000
					}));
			});
	}

	public importRecording(WebexSiteSettingsId: string, recordingId: string, title: string, recordingFileUrl: string, teamId?: string, transcriptionFileUrl?: string) {
		//create status entry
		const entry = this.UploadService.createImportStatusEntry(title, teamId);

		this.PushService.dispatchCommand('media:AddWebexVideoToAccount', {
			WebexSiteSettingsId,
			recordingId,
			title,
			teamId,
			recordingFileUrl,
			transcriptionFileUrl
		}, [
			'DownloadingVideoFailed',
			'OriginalVideoInstanceStoringFailed',
			'VideoProcessingFailed',
			IMPORT_RESPONSE_DOWNLOADING_FINISHED
		])
			.then(result => {
				// update status
				if (result.eventType === IMPORT_RESPONSE_DOWNLOADING_FINISHED) {
					entry.status.complete = true;
					entry.id = result.message ? result.message.videoId : null;
					entry.uploadDate = result.message ? result.message.when : null;
				}
				else {
					entry.status.error = true;
				}
			}).catch(() => {
				entry.status.error = true;
			});
	}
}
